import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
const NAV = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/90 backdrop-blur" data-id="element-78" data-mp="2ni7ixihgdplf">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6" data-id="element-79" data-mp="2rkb6h5heckn2">
        <a href="#home" className="flex items-center gap-2.5" aria-label="Flow State Plumbers home" data-id="element-80" data-mp="2wivxqfeo7tzd">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/098a9b0d-e676-4255-9e5f-030cb51f54a2.jpg" alt="" className="h-9 w-9 rounded-full object-cover" data-id="element-81" data-mp="31ebaf40xzju7" />
          <span className="font-heading text-lg font-semibold tracking-tight text-slate-900" data-id="element-82" data-mp="3fbglxjjfdawu">
            Flow State <span className="text-sky-600" data-id="element-83" data-mp="2wlduliys4t74">Plumbers</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary" data-id="element-84" data-mp="2rlrkvji5tv32">
          {NAV.map(item => <a key={item.label} href={item.href} className="text-sm font-medium text-slate-600 transition-colors hover:text-sky-600" data-id="element-85" data-mp="2mm5635moo6s5">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden md:block" data-id="element-86" data-mp="3fdf0v6dvvlqk">
          <a href="tel:5203000690" className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-slate-800" data-id="element-87" data-mp="3abprdv6b7g4l">
            <Phone className="h-4 w-4" data-id="element-88" data-mp="30lehzt3uweqb" />
            Call 520-300-0690
          </a>
        </div>

        <button type="button" className="inline-flex items-center justify-center rounded-md p-2 text-slate-700 md:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-89" data-mp="1xhc1ossslud">
          {open ? <X className="h-6 w-6" data-id="element-90" data-mp="1wbmjas1acz68" /> : <Menu className="h-6 w-6" data-id="element-91" data-mp="1wbuyiqkvsgkl" />}
        </button>
      </div>

      {open && <div className="border-t border-slate-200 bg-white md:hidden" data-id="element-92" data-mp="1hmyporb02zix">
          <nav className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-3" aria-label="Mobile" data-id="element-93" data-mp="1mm317oled9cf">
            {NAV.map(item => <a key={item.label} href={item.href} onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-94" data-mp="18liistje9fjg">
                {item.label}
              </a>)}
            <a href="tel:5203000690" className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white" data-id="element-95" data-mp="13o8u5g3tx7wo">
              <Phone className="h-4 w-4" data-id="element-96" data-mp="2xzxanmpplij6" />
              Call 520-300-0690
            </a>
          </nav>
        </div>}
    </header>;
}